import { render } from "./S318012.vue?vue&type=template&id=5a82ff43"
const script = {}
script.render = render

export default script